export function resolveEnvironmentName(): string {
  const configured =
    (import.meta.env['VITE_APP_ENV'] as string | undefined) ||
    (import.meta.env['VITE_ENV_NAME'] as string | undefined)
  if (configured) return configured.toLowerCase()

  if (typeof window === 'undefined') return 'dev'
  const host = window.location.hostname.toLowerCase()
  if (host.includes('staging')) return 'staging'
  if (host.includes('app.dashboardinsights.com')) return 'production'
  if (host.includes('portal.dashboardinsights.com')) return 'portal'
  if (host.includes('dev.dashboardinsights.com')) return 'dev'
  return 'dev'
}

export type AllowedEnvOption = { label: string; value: string }

export function getAllowedEnvOptions(): AllowedEnvOption[] {
  return [
    { label: ' ', value: '' },
    { label: 'Staging', value: 'staging' },
    { label: 'Prod', value: 'prod' },
  ]
}
